import { motion } from "framer-motion";
import { Download, FileText } from "lucide-react";
import Navigation from "../../components/Navigation";
import PageHero from "../../components/PageHero";

// Utility/Rental Assistance Page
const UtilityRentalAssistancePage = () => {
  const pdfUrl = "https://customer-assets.emergentagent.com/job_4bb091c1-e4be-474e-9067-19b51e555ba6/artifacts/4667dtt2_MGM2026%20Senior%20Resource%20Guide-Rental%20and%20Utility.pdf";

  return (
    <div data-testid="utility-rental-assistance-page" className="min-h-screen bg-[#FAFAFA]">
      <Navigation />
      
      <PageHero 
        image="https://customer-assets.emergentagent.com/job_7b46b431-509a-4162-84d5-ce52c765da4c/artifacts/w9bxx6km_Line%20outside%20door.jpg"
        alt="Utility and Rental Assistance"
      />

      {/* Content */}
      <section className="py-12 md:py-20 px-4 md:px-8 lg:px-12">
        <div className="max-w-4xl mx-auto">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <h1 
              data-testid="utility-rental-title"
              className="text-3xl md:text-4xl lg:text-5xl font-bold text-[#1A1A1A] mb-6"
              style={{ fontFamily: "'Playfair Display', serif" }}
            >
              Utility/Rental Assistance
            </h1>
            
            <p className="text-[#666666] text-base md:text-lg leading-relaxed mb-8">
              2026 Senior & Low-Income Resource Guide: Utility and Rental Assistance
            </p>

            {/* Download Card */}
            <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-6 md:p-8">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-[#C41E3A]/10 rounded-lg flex items-center justify-center flex-shrink-0">
                  <FileText className="text-[#C41E3A]" size={24} />
                </div>
                <div className="flex-1">
                  <h3 
                    className="font-bold text-[#1A1A1A] text-xl mb-2"
                    style={{ fontFamily: "'Playfair Display', serif" }}
                  >
                    Utility/Rental Assistance
                  </h3>
                  <p className="text-[#666666] mb-4">PDF Document</p>
                  <a 
                    href={pdfUrl}
                    download="MGM2026_Senior_Resource_Guide_Rental_and_Utility.pdf"
                    className="inline-flex items-center gap-2 bg-[#C41E3A] hover:bg-[#a31830] text-white px-6 py-3 rounded-full font-medium transition-colors"
                  >
                    <Download size={20} />
                    Download PDF
                  </a>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default UtilityRentalAssistancePage;
